import React from 'react';
import { 
  ResponsiveContainer,
  RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar
} from 'recharts';
import { getColorForValue } from '../../Utils/ColorUtils';

/**
 * A reusable radar chart component for displaying skills data
 * 
 * @param {Object} props - Component props
 * @param {Array} props.data - Array of data objects with subject and value properties
 * @param {string} props.title - Chart title
 * @param {string} props.valueKey - Key to use for the value in the data objects (default: "value")
 * @param {string} props.subjectKey - Key to use for the subject in the data objects (default: "subject")
 * @param {string} props.height - Height of the chart (default: "h-96")
 * @param {string} props.marginTop - Top margin (default: "mt-0")
 * @param {string} props.marginBottom - Bottom margin (default: "mb-4")
 * @param {string} props.chartColor - Color for the radar chart (default: "#3b82f6" - strong blue)
 */
const RadarChartComponent = ({ 
  data, 
  title, 
  valueKey = "value", 
  subjectKey = "subject",
  height = "h-96",
  marginTop = "mt-0",
  marginBottom = "mb-4",
  chartColor = "#3b82f6" // Strong blue
}) => {
  // Format data for the radar chart if needed
  const radarData = data.map(item => ({
    subject: item[subjectKey],
    A: item[valueKey],
    fullMark: 10
  }));
  
  return (
    <div className={`w-full ${height} ${marginTop} ${marginBottom}`}>
      {title && (
        <h5 className="text-lg font-medium text-gray-800 mb-2 text-center">{title}</h5>
      )}
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={radarData}>
          <PolarGrid />
          <PolarAngleAxis dataKey="subject" />
          <PolarRadiusAxis angle={30} domain={[0, 10]} />
          <Radar 
            name="Skills" 
            dataKey="A" 
            stroke={chartColor}
            fill={chartColor}
            fillOpacity={0.6}
            dot={(props) => {
              const { cx, cy, value } = props;
              return (
                <circle 
                  cx={cx} 
                  cy={cy} 
                  r={4} 
                  fill={getColorForValue(value)} 
                  stroke={getColorForValue(value)}
                />
              );
            }}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RadarChartComponent;
